

import DialoguePopup from "../../helpers/DialoguePopup";
import React, { useState, useRef, useEffect, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import BankService from "../../services/bank.services";
import BoLoader from "../../helpers/BoLoader";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import RefreshToken from "../../helpers/RefreshToken";
import ReactFlagsSelect from "react-flags-select";
import counties from "./Helpers/IsoCountriesList";
const AddCorporateBankAccountsBody = props => {
    const { user: currentUser } = useSelector(state => state.auth);

    const [cardHolderDetailsAreaSelected, setCardHolderDetailsAreaSelected] =
        useState("true");
    const [cardDetailsAreaSelected, setCardDetailsAreaSelected] =
        useState("false");
    const [cardHolderDetailsClassName, setTcardHolderDetailsClassName] =
        useState("nav-link active");
    const [cardDetailsClassName, setTcardDetailsClassName] = useState("nav-link");
    const [cardHolderContentClassName, setCardHolderContentClassName] = useState(
        "tab-pane fade show active"
    );
    const [cardContentClassName, setCardContentClassName] =
        useState("tab-pane fade");
    const [modalShow, setModalShow] = React.useState(false);
    const form = useRef();
    const checkBtn = useRef();
    const [modelhdng, setMdlHdng] = useState("");
    const [MdlIcon, setMdlIcon] = useState("");
    const [modelbdy, setMdlBdy] = useState("");
    const [disableBtns, setDisabledBtns] = useState(false);
    const [boloader, setBoLoader] = useState(false);
    const [ClientNameVal, setClientNameVal] = useState(currentUser?.user?.ClientId);
    const [FirstName, setFirstName] = useState("");
    const [PaymentProcessorClient, setPaymentProcessorClient] = useState("");
    const [cardFeeCurrencyCode, setcardFeeCurrencyCode] = useState();
    const [cardCurrency, setcardCurrency] = useState();
    const [showClientErr, setShowClientErr] = useState("d-none");
    const [errors, setErrors] = useState({}); // Error state

    //Issuer S or ISsuer B For m-Swipe
    const [IssuerCategory, setIssuerCategory] = useState();
    const [CardFlow, setCardFlow] = useState();
    const [CheckcardVisaMaster, setCheckCardVisaMaster] = useState("Select");
    const [formData, setFormData] = useState({
        registeredName: '',
        tradingName: '',
        currencyCode: 'USD',
        vendorsAndCounterparties: [], // Multi-select
        fundsSendReceiveJurisdictions: [], // Multi-select
        totalAssets: '',
        usdValueOfFiat: '',
        monthlyDeposits: '',
        monthlyWithdrawals: '',
        monthlyInvestmentDeposit: '',
        monthlyInvestmentWithdrawal: '',
        phone: '',
        emailAddress: '',
        // Registered Address
        registeredAddressLine1: '',
        registeredAddressLine2: '',
        registeredCity: '',
        registeredState: '',
        registeredCountryCode: '',
        registeredPostalCode: '',

        // Physical Address
        physicalAddressLine1: '',
        physicalAddressLine2: '',
        physicalCity: '',
        physicalState: '',
        physicalCountryCode: '',
        physicalPostalCode: '',

        websiteAddress: '',
        stateOfIncorporation: '',
        establishedOn: '', // Use date picker
        corporateEntityType:'C_CORP_PRIVATE',
        naics: '',
        naicsDescription: '',
        primaryBusiness: '',
        descriptionOfBusinessNature: '',
        primarySourceOfFunds: '',
        engageInActivities: 'NONE',
        regulatedStatus: '',
        registeredNumber:'',
        countryOfIncorporation:'',
        businessJurisdictions:[],
        clientId: currentUser?.user?.ClientId,
    });

    // Custom validation rules
    const validateField = (name, value) => {
        let errorMsg = "";

        // Ensure value is a string before using trim()
        const strValue = value !== undefined && value !== null ? String(value).trim() : "";
        
        if (!strValue) {
            errorMsg = `${name} is required`;
        } else {
            if (name === "email" && !/^\S+@\S+\.\S+$/.test(strValue)) {
                errorMsg = "Invalid email format";
            }
            if (name === "phone" && !/^\+?\d{10,15}$/.test(strValue)) {
                errorMsg = "Invalid phone number (must be 10-15 digits, optional leading +)";
            }
        }

        return errorMsg;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validate field
        const errorMsg = validateField(name, value);

        // Update state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Update errors
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };
    //API Call Start
    const IssueCardHolderHandler = e => {
        if (e) e.preventDefault();
        form.current.validateAll();

        formData.clientId = Number(ClientNameVal);
        let newErrors = {};
        Object.keys(formData).forEach((field) => {
            const errorMsg = validateField(field, formData[field]);
            if (errorMsg) newErrors[field] = errorMsg;
        });
        // If errors exist, update state and stop submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        
            setBoLoader(true);
            BankService.createcorporateaccount
                (formData,
                )
                .then(bankData => {
                    setBoLoader(false);
                    if (bankData && bankData.data && bankData.data.success) {
                        let errIcon = "icon-success";
                        let msgBody= "Account created Successfully please check your email !"
                        errorAndSuccessModl("Success", msgBody, errIcon);
                    }
                })
                .catch(err => {
                    setBoLoader(false);
                    let msgBody =
                        err && err.response && err.response.data
                            ? err.response.data.message
                            : "Error Occured While Creating Account";
                    let errIcon = "icon-error";
                    errorAndSuccessModl("Error", msgBody, errIcon);
                    (async () => {
                        setBoLoader(true);
                        let resp = await RefreshToken(
                            err && err.response && err.response.status
                        );
                        if (resp) {
                            IssueCardHolderHandler();
                            setBoLoader(false);
                        } else {
                            setBoLoader(false);
                        }
                    })();
                });
        

    };
    //API Call End
    const errorAndSuccessModl = (heading, body, Icon) => {
        setModalShow(true);
        setMdlHdng(heading);
        setMdlBdy(body);
        setMdlIcon(Icon);
    };

    const IssueCardDoneHandler = e => {
        e.preventDefault();
        // setDisabledBtns(true);
        props.onHide();
    };
   

    return (
        <Fragment>
            <div className="row">
                <BoLoader loading={boloader} />
                <div className="col-md-12">
                    <h2>Create Corporate Account </h2>
                    <div className="mt-16">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="bo-tabs-mbl">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={cardHolderDetailsClassName} //""
                                                id="cardHolder-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#cardHolder"
                                                type="button"
                                                role="tab"
                                                aria-controls="cardHolder"
                                                aria-selected={cardHolderDetailsAreaSelected}
                                            >
                                                AccountHolder Details
                                            </button>
                                        </li>
                                        
                                    </ul>
                                </div>

                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className={cardHolderContentClassName}
                                        id="cardHolder"
                                        role="tabpanel"
                                        aria-labelledby="cardHolder-tab"
                                    >
                                        <div>
                                            <h3>Enter Corporate Account details</h3>
                                            <Form onSubmit={(e) => { e.preventDefault() }} ref={form}>
                                                <div className="row mt-16">
                                                    
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredName">
                                                            <label>Registered Name*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredName"
                                                                    value={formData.registeredName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.registeredName && (
                                                                <span className="error_meesage">{errors.registeredName}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredNumber">
                                                            <label>Registered Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredNumber"
                                                                    value={formData.registeredNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.registeredNumber && (
                                                                <span className="error_meesage">{errors.registeredNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Website Address */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_websiteAddress">
                                                            <label>Website Address*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="websiteAddress"
                                                                    value={formData.websiteAddress}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.websiteAddress && (
                                                                <span className="error_message">{errors.websiteAddress}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Trading Name */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="tradingName">
                                                            <label>Trading Name*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="tradingName"
                                                                    value={formData.tradingName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.tradingName && (
                                                                <span className="error_meesage">{errors.tradingName}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Vendors and Counterparties */}

                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_vendorsAndCounterparties">
                                                            <label>Vendors and Counterparties*</label>
                                                            <div className="form-controls">
                                                                {/* Searchable input with selected values */}
                                                                <div className="selected-tags">
                                                                    {formData.vendorsAndCounterparties.map((code) => (
                                                                        <span key={code} className="selected-tag">
                                                                            {code}{" "}
                                                                            <button
                                                                                type="button"
                                                                                className="cross-icon"
                                                                                onClick={() => {
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        vendorsAndCounterparties: prev.vendorsAndCounterparties.filter(
                                                                                            (c) => c !== code
                                                                                        ),
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control no-icon d-none"
                                                                        placeholder="Select jurisdictions"
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                {/* Multi-select dropdown */}
                                                                <select
                                                                    className="form-control no-icon mt-2"
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        if (
                                                                            selectedValue &&
                                                                            !formData.vendorsAndCounterparties.includes(selectedValue)
                                                                        ) {
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                vendorsAndCounterparties: [
                                                                                    ...prev.vendorsAndCounterparties,
                                                                                    selectedValue,
                                                                                ],
                                                                            }));
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="SELF">Self</option>
                                                                    <option value="MERCHANTS_SUPPLIERS">Merchants & Suppliers</option>
                                                                    <option value="CUSTOMERS">Customers</option>
                                                                    <option value="EMPLOYEES">Employees</option>
                                                                    <option value="CONTRACTORS">Contractors</option>
                                                                    <option value="FRIENDS">Friends</option>
                                                                    <option value="FAMILY">Family</option>
                                                                </select>
                                                            </div>

                                                            {errors.vendorsAndCounterparties && (
                                                                <span className="error_meesage">{errors.vendorsAndCounterparties}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Funds Send/Receive Jurisdictions */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_fundsSendReceiveJurisdictions">
                                                            <label>Funds Send/Receive Jurisdictions*</label>
                                                            <div className="form-controls">
                                                                {/* Searchable input with selected values */}
                                                                <div className="selected-tags">
                                                                    {formData.fundsSendReceiveJurisdictions.map((code) => (
                                                                        <span key={code} className="selected-tag">
                                                                            {code}{" "}
                                                                            <button
                                                                                type="button"
                                                                                className="cross-icon"
                                                                                onClick={() => {
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        fundsSendReceiveJurisdictions: prev.fundsSendReceiveJurisdictions.filter(
                                                                                            (c) => c !== code
                                                                                        ),
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control no-icon d-none"
                                                                        placeholder="Select jurisdictions"
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                {/* Multi-select dropdown */}
                                                                <select
                                                                    className="form-control no-icon mt-2"
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        if (
                                                                            selectedValue &&
                                                                            !formData.fundsSendReceiveJurisdictions.includes(selectedValue)
                                                                        ) {
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                fundsSendReceiveJurisdictions: [
                                                                                    ...prev.fundsSendReceiveJurisdictions,
                                                                                    selectedValue,
                                                                                ],
                                                                            }));
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">Select country...</option>
                                                                    {counties.map((country) => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name} ({country.code})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {errors.fundsSendReceiveJurisdictions && (
                                                                <span className="error_meesage">{errors.fundsSendReceiveJurisdictions}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_businessJurisdictions">
                                                            <label>Business Jurisdictions*</label>
                                                            <div className="form-controls">
                                                                {/* Searchable input with selected values */}
                                                                <div className="selected-tags">
                                                                    {formData.businessJurisdictions.map((code) => (
                                                                        <span key={code} className="selected-tag">
                                                                            {code}{" "}
                                                                            <button
                                                                                type="button"
                                                                                className="cross-icon"
                                                                                onClick={() => {
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        businessJurisdictions: prev.businessJurisdictions.filter(
                                                                                            (c) => c !== code
                                                                                        ),
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control no-icon d-none"
                                                                        placeholder="Select jurisdictions"
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                {/* Multi-select dropdown */}
                                                                <select
                                                                    className="form-control no-icon mt-2"
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        if (
                                                                            selectedValue &&
                                                                            !formData.businessJurisdictions.includes(selectedValue)
                                                                        ) {
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                businessJurisdictions: [
                                                                                    ...prev.businessJurisdictions,
                                                                                    selectedValue,
                                                                                ],
                                                                            }));
                                                                        }
                                                                    }}
                                                                >
                                                                     <option value="">Select country...</option>
                                                                    {counties.map((country) => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name} ({country.code})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {errors.businessJurisdictions && (
                                                                <span className="error_meesage">{errors.businessJurisdictions}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Total Assets */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_totalAssets">
                                                            <label>Total Assets*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="totalAssets"
                                                                    value={formData.totalAssets}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_10K">0 to 10,000</option>
                                                                    <option value="TEN_TO_100K">10,000 to 100,000</option>
                                                                    <option value="ONEHUNDREDK_TO_1M">100,000 to 1,000,000</option>
                                                                    <option value="ONE_TO_10M">1,000,000 to 10,000,000</option>
                                                                    <option value="TEN_TO_50M">10,000,000 to 50,000,000</option>
                                                                    <option value="FIFTY_TO_250M">50,000,000 to 250,000,000</option>
                                                                    <option value="MORE_THAN_250M">250,000,000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.totalAssets && (
                                                                <span className="error_meesage">{errors.totalAssets}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* USD Value of Fiat */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_usdValueOfFiat">
                                                            <label>USD Value of Fiat*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="usdValueOfFiat"
                                                                    value={formData.usdValueOfFiat}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_10K">0 to 10,000</option>
                                                                    <option value="TEN_TO_100K">10,000 to 100,000</option>
                                                                    <option value="ONEHUNDREDK_TO_1M">100,000 to 1,000,000</option>
                                                                    <option value="ONE_TO_10M">1,000,000 to 10,000,000</option>
                                                                    <option value="TEN_TO_50M">10,000,000 to 50,000,000</option>
                                                                    <option value="FIFTY_TO_250M">50,000,000 to 250,000,000</option>
                                                                    <option value="MORE_THAN_250M">250,000,000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.usdValueOfFiat && (
                                                                <span className="error_meesage">{errors.usdValueOfFiat}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Monthly Deposits */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_monthlyDeposits">
                                                            <label>Monthly Deposits*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="monthlyDeposits"
                                                                    value={formData.monthlyDeposits}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_5">0 to 5000</option>
                                                                    <option value="FIVE_TO_10">5000 to 10000</option>
                                                                    <option value="TEN_TO_25">10000 to 25000</option>
                                                                    <option value="MORE_THAN_25">25000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.monthlyDeposits && (
                                                                <span className="error_meesage">{errors.monthlyDeposits}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Monthly Withdrawals */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_monthlyWithdrawals">
                                                            <label>Monthly Withdrawals*</label>
                                                            <div className="form-controls no-icon">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="monthlyWithdrawals"
                                                                    value={formData.monthlyWithdrawals}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_5">0 to 5000</option>
                                                                    <option value="FIVE_TO_10">5000 to 10000</option>
                                                                    <option value="TEN_TO_25">10000 to 25000</option>
                                                                    <option value="MORE_THAN_25">25000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.monthlyWithdrawals && (
                                                                <span className="error_meesage">{errors.monthlyWithdrawals}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Monthly Investment Deposit */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_monthlyInvestmentDeposit">
                                                            <label>Monthly Investment Deposit*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="monthlyInvestmentDeposit"
                                                                    value={formData.monthlyInvestmentDeposit}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_1K">0 to 1,000</option>
                                                                    <option value="ONE_TO_100K">1,000 to 100,000</option>
                                                                    <option value="ONEHUNDREDK_TO_1M">100,000 to 1,000,000</option>
                                                                    <option value="MILLION_TO_5M">1,000,000 to 5,000,000</option>
                                                                    <option value="MORE_THAN_5M">5,000,000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.monthlyInvestmentDeposit && (
                                                                <span className="error_meesage">{errors.monthlyInvestmentDeposit}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Monthly Investment Withdrawal */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_monthlyInvestmentWithdrawal">
                                                            <label>Monthly Investment Withdrawal*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="monthlyInvestmentWithdrawal"
                                                                    value={formData.monthlyInvestmentWithdrawal}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="UPTO_1K">0 to 1,000</option>
                                                                    <option value="ONE_TO_100K">1,000 to 100,000</option>
                                                                    <option value="ONEHUNDREDK_TO_1M">100,000 to 1,000,000</option>
                                                                    <option value="MILLION_TO_5M">1,000,000 to 5,000,000</option>
                                                                    <option value="MORE_THAN_5M">5,000,000+</option>
                                                                </select>
                                                            </div>
                                                            {errors.monthlyInvestmentWithdrawal && (
                                                                <span className="error_meesage">{errors.monthlyInvestmentWithdrawal}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Phone */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_phone">
                                                            <label>Phone*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="tel"
                                                                    className="form-control no-icon"
                                                                    name="phone"
                                                                    value={formData.phone}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.phone && (
                                                                <span className="error_meesage">{errors.phone}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_email">
                                                            <label>Email*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="email"
                                                                    className="form-control no-icon"
                                                                    name="emailAddress"
                                                                    value={formData.emailAddress}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.emailAddress && (
                                                                <span className="error_meesage">{errors.emailAddress}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    
                                                    {/* registeredAddressLine1 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredAddressLine1">
                                                            <label>Registered Address Line 1</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredAddressLine1"
                                                                    value={formData.registeredAddressLine1}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.registeredAddressLine1 && (
                                                                <span className="error_meesage">{errors.registeredAddressLine1}</span>
                                                            )}

                                                        </div>
                                                    </div>

                                                    {/* Registered Address Line 2 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredAddressLine2">
                                                            <label>Registered Address Line2*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredAddressLine2"
                                                                    value={formData.registeredAddressLine2}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.registeredAddressLine2 && (
                                                                <span className="error_meesage">{errors.registeredAddressLine2}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Mailing City */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredCity">
                                                            <label>Registered City*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredCity"
                                                                    value={formData.registeredCity}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.registeredCity && (
                                                                <span className="error_meesage">{errors.registeredCity}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Mailing State Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredState">
                                                            <label>Registered State*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredState"
                                                                    value={formData.registeredState}
                                                                    onChange={handleChange}
                                                                    maxLength="2"
                                                                />
                                                            </div>
                                                            {errors.registeredState && (
                                                                <span className="error_meesage">{errors.registeredState}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredCountryCode">
                                                            <label>Registered Country*</label>
                                                            <div className="form-controls">
                                                                <ReactFlagsSelect
                                                                    className="form-control no-icon"
                                                                    selected={formData.registeredCountryCode}
                                                                    onSelect={(code) => {
                                                                        handleChange({ target: { name: 'registeredCountryCode', value: code } });
                                                                    }}
                                                                    searchable={true}
                                                                />

                                                            </div>
                                                            {errors.registeredCountryCode && (
                                                                <span className="error_meesage">{errors.registeredCountryCode}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group" id="countryOfIncorporation">
                                                            <label>Country Of Incorporation*</label>
                                                            <div className="form-controls">
                                                                <ReactFlagsSelect
                                                                    className="form-control no-icon"
                                                                    selected={formData.countryOfIncorporation}
                                                                    onSelect={(code) => {
                                                                        handleChange({ target: { name: 'countryOfIncorporation', value: code } });
                                                                    }}
                                                                    searchable={true}
                                                                />

                                                            </div>
                                                            {errors.countryOfIncorporation && (
                                                                <span className="error_meesage">{errors.countryOfIncorporation}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Registered Postal Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="registeredPostalCode">
                                                            <label>Registered Postal Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="registeredPostalCode"
                                                                    value={formData.registeredPostalCode}
                                                                    onChange={handleChange}
                                                                    maxLength="10"
                                                                />
                                                            </div>
                                                            {errors.registeredPostalCode && (
                                                                <span className="error_meesage">{errors.registeredPostalCode}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Copy Registered Address to Physical Address */}
<div className="col-md-12">
    <div className="form-group d-flex align-items-center">
        <input
            type="checkbox"
            id="sameAsRegistered"
            style={{ marginRight: "8px", transform: "scale(1.2)" }} // Adjust spacing and size
            onChange={(e) => {
                if (e.target.checked) {
                    setFormData((prev) => ({
                        ...prev,
                        physicalAddressLine1: prev.registeredAddressLine1,
                        physicalAddressLine2: prev.registeredAddressLine2,
                        physicalCity: prev.registeredCity,
                        physicalState: prev.registeredState,
                        physicalCountryCode: prev.registeredCountryCode,
                        physicalPostalCode: prev.registeredPostalCode,
                    }));
                } else {
                    setFormData((prev) => ({
                        ...prev,
                        physicalAddressLine1: '',
                        physicalAddressLine2: '',
                        physicalCity: '',
                        physicalState: '',
                        physicalCountryCode: '',
                        physicalPostalCode: '',
                    }));
                }
            }}
        />
        <label htmlFor="sameAsRegistered" style={{ marginBottom: "-8px", cursor: "pointer",marginTop:"1px",color:"#89455E" }}>
            Same as Registered Address
        </label>
    </div>
</div>
                                                    {/* Physical Address Line 1 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalAddressLine1">
                                                            <label>Physical Address Line 1*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalAddressLine1"
                                                                    value={formData.physicalAddressLine1}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.physicalAddressLine1 && (
                                                                <span className="error_message">{errors.physicalAddressLine1}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Physical Address Line 2 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalAddressLine2">
                                                            <label>Physical Address Line 2*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalAddressLine2"
                                                                    value={formData.physicalAddressLine2}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.physicalAddressLine2 && (
                                                                <span className="error_message">{errors.physicalAddressLine2}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Physical City */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalCity">
                                                            <label>Physical City*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalCity"
                                                                    value={formData.physicalCity}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.physicalCity && (
                                                                <span className="error_message">{errors.physicalCity}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Physical State */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalState">
                                                            <label>Physical State*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalState"
                                                                    value={formData.physicalState}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.physicalState && (
                                                                <span className="error_message">{errors.physicalState}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Physical Country Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalCountryCode">
                                                            <label>Physical Country Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalCountryCode"
                                                                    value={formData.physicalCountryCode}
                                                                    onChange={handleChange}
                                                                    maxLength="2"
                                                                />
                                                            </div>
                                                            {errors.physicalCountryCode && (
                                                                <span className="error_message">{errors.physicalCountryCode}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Physical Postal Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_physicalPostalCode">
                                                            <label>Physical Postal Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="physicalPostalCode"
                                                                    value={formData.physicalPostalCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.physicalPostalCode && (
                                                                <span className="error_message">{errors.physicalPostalCode}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    

                                                    {/* State of Incorporation */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_stateOfIncorporation">
                                                            <label>State of Incorporation*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="stateOfIncorporation"
                                                                    value={formData.stateOfIncorporation}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.stateOfIncorporation && (
                                                                <span className="error_message">{errors.stateOfIncorporation}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Established On (Date Picker) */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_establishedOn">
                                                            <label>Established On*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="date"
                                                                    className="form-control no-icon"
                                                                    name="establishedOn"
                                                                    value={formData.establishedOn}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.establishedOn && (
                                                                <span className="error_message">{errors.establishedOn}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Corporate Entity Type */}
                                                    {/* <div className="col-md-6">
                                                        <div className="form-group" id="id_corporateEntityType">
                                                            <label>Corporate Entity Type*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="corporateEntityType"
                                                                    value={formData.corporateEntityType}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.corporateEntityType && (
                                                                <span className="error_message">{errors.corporateEntityType}</span>
                                                            )}
                                                        </div>
                                                    </div> */}

                                                    {/* NAICS */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_naics">
                                                            <label>NAICS*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="naics"
                                                                    value={formData.naics}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.naics && (
                                                                <span className="error_message">{errors.naics}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* NAICS Description */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_naicsDescription">
                                                            <label>NAICS Description*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="naicsDescription"
                                                                    value={formData.naicsDescription}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.naicsDescription && (
                                                                <span className="error_message">{errors.naicsDescription}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Primary Business */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_primaryBusiness">
                                                            <label>Primary Business*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="primaryBusiness"
                                                                    value={formData.primaryBusiness}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="SOFTWARE">Software</option>
                                                                    <option value="ATM">ATM</option>
                                                                    <option value="BROKER">Broker</option>
                                                                    <option value="CHARITY">Charity</option>
                                                                    <option value="COMMODITIES">Commodities</option>
                                                                    <option value="DEFI_EXCHANGE">DeFi Exchange</option>
                                                                    <option value="GOVERNMENT_FOREIGN">Government (Foreign)</option>
                                                                    <option value="GOVERNMENT_US">Government (US)</option>
                                                                    <option value="HNWI">HNWI</option>
                                                                    <option value="INSURANCE">Insurance</option>
                                                                    <option value="ADVISOR">Advisor</option>
                                                                    <option value="LOAN">Loan</option>
                                                                    <option value="MINER">Miner</option>
                                                                    <option value="NFT">NFT</option>
                                                                    <option value="NON_BANK_CUSTODIAN">Non-Bank Custodian</option>
                                                                    <option value="PENSION">Pension</option>
                                                                    <option value="WHV">WHV</option>
                                                                    <option value="POOLED_INVESTMENT">Pooled Investment</option>
                                                                    <option value="PROP_TRADING">Prop Trading</option>
                                                                    <option value="PUBLIC">Public</option>
                                                                    <option value="SPV">SPV</option>
                                                                    <option value="STATE_FOREIGN">State Foreign</option>
                                                                    <option value="STATE_US">State US</option>
                                                                    <option value="SUPRANATIONAL_BODY">Supranational Body</option>
                                                                    <option value="PAYMENT_PROCESSOR">Payment Processor</option>
                                                                    <option value="TOKEN_PROJECT">Token Project</option>
                                                                    <option value="TRUST_PERSONAL">Trust Personal</option>
                                                                    <option value="TRUST_CORP">Trust Corp</option>
                                                                    <option value="BANK_US">Bank US</option>
                                                                    <option value="BANK_FOREIGN">Bank Foreign</option>
                                                                    <option value="CRYPTO_MSB_US">Crypto MSB US</option>
                                                                    <option value="CRYPTO_MSB_FOREIGN">Crypto MSB Foreign</option>
                                                                    <option value="NON_CRYPTO_MSB_US">Non-Crypto MSB US</option>
                                                                    <option value="NON_CRYPTO_MSB_FOREIGN">Non-Crypto MSB Foreign</option>
                                                                    <option value="OTHER">Other</option>
                                                                </select>
                                                            </div>
                                                            {errors.primaryBusiness && (
                                                                <span className="error_message">{errors.primaryBusiness}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Description of Business Nature */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_descriptionOfBusinessNature">
                                                            <label>Description of Business Nature*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="descriptionOfBusinessNature"
                                                                    value={formData.descriptionOfBusinessNature}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.descriptionOfBusinessNature && (
                                                                <span className="error_message">{errors.descriptionOfBusinessNature}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Primary Source of Funds */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_primarySourceOfFunds">
                                                            <label>Primary Source of Funds*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="primarySourceOfFunds"
                                                                    value={formData.primarySourceOfFunds}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="EMPLOYMENT">Employment</option>
                                                                    <option value="SAVINGS">Savings</option>
                                                                    <option value="WINNINGS">Winnings</option>
                                                                    <option value="MARITAL">Marital</option>
                                                                    <option value="REAL_ESTATE">Real Estate</option>
                                                                    <option value="TRUST">Trust</option>
                                                                    <option value="INVESTMENT">Investment</option>
                                                                    <option value="COMPANY">Company</option>
                                                                    <option value="COMPANY_CAPITAL">Company Capital</option>
                                                                    <option value="LOAN">Loan</option>
                                                                    <option value="PRIVATE_CAPITAL">Private Capital</option>
                                                                    <option value="GRANT">Grant</option>
                                                                    <option value="OTHER">Other</option>
                                                                </select>
                                                            </div>
                                                            {errors.primarySourceOfFunds && (
                                                                <span className="error_message">{errors.primarySourceOfFunds}</span>
                                                            )}
                                                        </div>
                                                    </div>


                                                    {/* Regulated Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_regulatedStatus">
                                                            <label>Regulated Status*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="regulatedStatus"
                                                                    value={formData.regulatedStatus}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="REGULATED">Regulated</option>
                                                                    <option value="REGISTERED">Registered</option>
                                                                    <option value="LICENSED">Licensed</option>
                                                                    <option value="NONE">None</option>
                                                                </select>
                                                            </div>
                                                            {errors.regulatedStatus && (
                                                                <span className="error_message">{errors.regulatedStatus}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                                                            <a
                                                                className="btn btn-outline mr-19"
                                                                data-bs-dismiss="modal"
                                                                onClick={props.onHide}
                                                            >
                                                                Cancel
                                                            </a>
                                                            <a className="btn btn-large" onClick={IssueCardHolderHandler}>
                                                                Create Account
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <CheckButton
                                                    style={{ display: "none" }}
                                                    ref={checkBtn}
                                                />
                                            </Form>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialoguePopup
                show={modalShow}
                onHide={() => setModalShow(false)}
                modelheading={modelhdng}
                modelbody={modelbdy}
                modelicon={MdlIcon}
                hideallpopups={props.onHide}
            />
        </Fragment>
    );
};
export default AddCorporateBankAccountsBody;
